import { request } from '@/utils/axios'

// const REQUEST_ORIGIN = '/'

export function apiLogin(data) {
  return request({
    url: '/v1/user_admin/login',
    data,
    headers: {
      'X-Shanhai-Service': 'AuthAdmin'
    }
  })
}
// 用户资料更新
export function apiUpdateUserInfo(data) {
  return request({
    method: 'post',
    url: '/v1/user_admin/update',
    data,
    headers: {
      'X-Shanhai-Service': 'AuthAdmin'
    }
  })
}
// 获取验证码
export function apiGetCode(data) {
  return request({
    method: 'post',
    url: '/v1/user_admin/generate_captcha',
    data,
    headers: {
      'X-Shanhai-Service': 'AuthAdmin'
    }
  })
}
// 用户菜单列表
export function apiGetMenus(data?) {
  return request<MenusRes>({
    method: 'post',
    url: '/v1/user_admin/menus',
    data,
    headers: {
      'X-Shanhai-Service': 'AuthAdmin'
    }
  })
}
